export default "__VITE_ASSET__B8qR7gbK__"